import { render, staticRenderFns } from "./allGift.vue?vue&type=template&id=ebf2674c"
import script from "./allGift.vue?vue&type=script&lang=js"
export * from "./allGift.vue?vue&type=script&lang=js"
import style0 from "./allGift.vue?vue&type=style&index=0&id=ebf2674c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports